/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthMonitorModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import {
    HealthMonitor,
    HealthMonitorSIP,
} from 'object-types';

import {
    HealthMonitorItem,
} from 'ajs/modules/healthmonitor/factories/health-monitor-item.factory';

import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';
import * as l10n from './sip-health-monitor-config.l10n';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Health Monitor Config Component for SIP Health Monitor Type.
 *
 * @author Rajawant Prajapati
 */
@Component({
    selector: 'sip-health-monitor-config',
    templateUrl: './sip-health-monitor-config.component.html',
})
export class SipHealthMonitorConfigComponent {
    /**
     * SIP Health Monitor Message Item.
     */
    @Input()
    public editable: HealthMonitorItem;

    /**
     * ObjectTypes of SIP Health Monitor.
     */
    public readonly objectTypes = {
        HealthMonitor,
        HealthMonitorSIP,
    };

    /**
     * For template usage.
     */
    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
